import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/ATPlab.png'
import _imports_1 from '@/assets/CSBD.png'
import _imports_2 from '@/assets/MPI_CBG_Logo_horizontal_black.png'


const _hoisted_1 = { class: "p-4 shadow-sm" }
const _hoisted_2 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "p-2" }
const _hoisted_4 = ["href"]


export default /*@__PURE__*/_defineComponent({
  __name: 'PageFooters',
  setup(__props) {

const mailing_list = `${process.env.VUE_APP_MAILING_LIST_EMAIL}`;

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode(" Powered by: <div class=\"flex-column\" data-v-306466e7><a class=\"img\" href=\"https://www.mpi-cbg.de/research/researchgroups/currentgroups/agnes-toth-petroczy\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-306466e7><img src=\"" + _imports_0 + "\" class=\"col-md-2\" alt=\"ATPlab Logo\" data-v-306466e7></a><a class=\"img\" href=\"https://mpi-cbg.de\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-306466e7><img src=\"" + _imports_1 + "\" class=\"col-md-2\" alt=\"CSBD Logo\" data-v-306466e7></a><a class=\"img-2\" href=\"https://mpi-cbg.de\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-306466e7><img src=\"" + _imports_2 + "\" class=\"col-md-4\" alt=\"MPI-CBG Logo\" data-v-306466e7></a></div><hr data-v-306466e7>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"p-2\" data-v-306466e7><a href=\"/imprint\" data-v-306466e7>Impressum</a>   |   <a href=\"/privacy-policy\" data-v-306466e7>Privacy Policy</a></div><div class=\"p-2\" data-v-306466e7><span data-v-306466e7>© 2025 <a href=\"/\" data-v-306466e7>PICNIC</a>. All Rights Reserved. </span></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: 'mailto:' + mailing_list
        }, [
          _createVNode(_component_font_awesome_icon, {
            size: "xl",
            icon: "fa-solid fa-envelope"
          })
        ], 8, _hoisted_4)
      ])
    ]),
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"flex-row\" data-v-306466e7><div class=\"align-text-bottom\" data-v-306466e7><span data-v-306466e7> This work is licensed under a <a rel=\"license\" href=\"http://creativecommons.org/licenses/by-sa/4.0/\" target=\"_blank\" data-v-306466e7>Creative Commons Attribution-ShareAlike 4.0 International License </a>   <a rel=\"license\" href=\"http://creativecommons.org/licenses/by-sa/4.0/\" data-v-306466e7><img alt=\"Creative Commons License\" style=\"border-width:0;top:0;bottom:0;margin:auto;\" src=\"https://i.creativecommons.org/l/by-sa/4.0/80x15.png\" data-v-306466e7></a></span></div></div>", 1))
  ]))
}
}

})